import { FilteringState } from 'features/resultFiltering/resultFilteringSlice';

import { SearchResultsGroupMember } from '../searchMoleculesSlice';

export const inFilter = (member: SearchResultsGroupMember, filters: FilteringState) => {
  const inRange = Object.keys(filters).map((name) => {
    if (
      !(name in member.calculations) ||
      (member.calculations[name] >= filters[name].values[0] &&
        member.calculations[name] <= filters[name].values[1])
    ) {
      return true;
    }
    return false;
  });

  return inRange.every((b) => b);
};
